"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CoachOnlyToggle = _interopRequireDefault(require("./CoachOnlyToggle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _CoachOnlyToggle.default;
exports.default = _default;